export default {
  sections: {
    setup_fee: {
      title: 'Koszty konfiguracji',
      description: 'Koszty konfiguracji od {{amount}} – zamiast 1000+',
    },
  },
  labels: {
    month: 'Miesiąc (netto)',
    one_time_fee: 'Opłata jednorazowa',
    more_options: 'Więcej opcji',
    discount_badge: '-{{percentage}}%',
  },
  features: {
    app: 'Własna aplikacja w App Store i Google Play',
    push_notifications: 'Powiadomienia push o ofertach',
    loyalty: 'Utrzymanie klientów przez programy lojalnościowe',
    offline_orders: 'Możliwość zamówień offline',
    individual_design: 'Indywidualny design aplikacji',
  },
  setup_fee_options: {
    150: 'Standardowa konfiguracja',
    75: 'Obniżona',
    0: 'Bez kosztów konfiguracji',
  },
  feedback: {
    contract_signed_already: {
      title: 'Umowa jest już podpisana',
      description: 'Skontaktuj się z pomocą techniczną, jeśli potrzebujesz wprowadzić zmiany',
    },
  },
};
